import { api } from '#/apis';
import Swal from '#/swal';

const internals = {};


internals.reduceToObject = (data, justName = false) => data.reduce((acc, curr) => ({
    ...acc,
    [curr.id]: justName ? curr.name : curr
}), {});


export const selectModal = async (dataUrl, name) => {
    const { data } = await api.get(dataUrl);
    const { value } = await Swal.fire({
        title: `Select ${name}`,
        input: 'select',
        inputOptions: internals.reduceToObject(data, true),
        inputPlaceholder: `Select a ${name}`,
        showCancelButton: true,
        inputValidator: value => {
            if (!value) {
                return 'You need to choose something!';
            }
        }
    });

    return internals.reduceToObject(data)[value];
};
